module.exports = __webpack_public_path__ + "img/new-dapps-page.9ddaa47c.png";